import React, { ReactElement } from 'react';
import styled from 'styled-components';
import { Button as AntButton } from 'antd';
import { colorsPalette } from '../../styles/colors-palette';

interface CustomStyle {
  paddingRight?: CSSSize;
  marginRight?: CSSSize;
  width?: CSSSize;
}

interface IconButtonProps {
  disabled?: boolean;
  onClick?: (event?) => void;
  className?: string;
  size?: ButtonSize;
  icon?: React.ReactNode;
  children?: React.ReactNode;
  customStyle?: CustomStyle;
}

type ButtonSize = 'large' | 'small' | 'middle';

function IconButton({
  onClick,
  disabled,
  icon,
  size,
  className,
  children,
  customStyle,
}: IconButtonProps): ReactElement {
  return (
    <StyledButton
      customstyle={customStyle}
      type={'link'}
      onClick={onClick}
      className={className}
      size={size}
      disabled={disabled}
      icon={icon}
    >
      {children}
    </StyledButton>
  );
}

const StyledButton = styled(AntButton)<{ customstyle?: CustomStyle }>`
  &.ant-btn-link {
    color: ${colorsPalette.gray600};
    padding-right: ${props => props.customstyle?.paddingRight};
    width: ${props => props.customstyle?.width};
    margin-right: ${props => props.customstyle?.marginRight};
  }

  &.ant-btn-variant-link:disabled {
    color: ${colorsPalette.gray100};
  }
`;

export default IconButton;
